module.exports = __webpack_public_path__ + "img/price-1790.1b5c1b61.png";